export default function Marquee() {
    const items = [
        "MONO RAIL",
        "BMU SYSTEM",
        "DOUBLE DECKER",
        "TOWER HOIST",
        "FLOOR CRANE",
        "SUSPENDED ROPE PLATFORM",
    ];
    const Track = ({ hidden }) => (
        <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
            {items.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-wider text-slate-400 md:text-3xl">
                        {item}
                    </span>
                    <span className="h-2 w-2 rotate-45 bg-accent" aria-hidden="true" />
                </span>
            ))}
        </div>
    );
    return (
        <section
            data-testid="services-marquee"
            className="relative overflow-hidden border-y border-line bg-deck py-6"
        >
            <div className="marquee-track">
                <Track />
                <Track hidden={true} />
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-night to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-night to-transparent" />
        </section>
    );
}
